import { TranscribeVideoPayload } from 'types/store/TranscribeVideo';
import { createAsyncReducer } from 'utils/Redux';

import { transcribeStoryActions } from '../actions';

export default createAsyncReducer<string, TranscribeVideoPayload>(
  transcribeStoryActions,
);
